__webpack_require__.p = "/~wics/hopperhacks/2024/";